import { Title, Flex, Stack } from '@mantine/core';

import {
  MRT_TableInstance,
  MRT_Row,
  MRT_EditActionButtons,
} from 'mantine-react-table';
import { Provider } from 'interfaces';

interface ProviderCreateModalProps {
  table: MRT_TableInstance<Provider>;
  row: MRT_Row<Provider>;
  internalEditComponents?: React.ReactNode[];
}

export const ProviderCreateModal: React.FC<ProviderCreateModalProps> = ({
  table,
  row,
  internalEditComponents,
}) => {
  return (
    <Stack>
      <Title order={3}>Add Provider</Title>
      {internalEditComponents}
      <Flex justify="end">
        <MRT_EditActionButtons table={table} row={row} variant="text" />
      </Flex>
    </Stack>
  );
};
